// src/config/navbarLinks.js
export const navbarLinks = [
  {
    title: 'nav.play',
    items: [
      {
        title: 'nav.poker',
        mobileTitle: "nav.playPoker",
        img: 'nav/poker-menu.jpg',
        imgAlt: 'nav.poker',
        items: [
          { categoryTitle: true, route: 'routes.poker', title: 'nav.poker', img: 'nav/poker-menu.jpg', imgAlt: 'nav.poker', icon: 'poker' },
          { route: 'routes.cashGames', title: 'nav.cashGames', icon: 'cashGames' },
          { route: 'routes.pokerTournamentCalendar', title: 'nav.tournamentCalendar', badge: 'buy-tickets', icon: 'tournamentCal' },
          { route: 'tournaments.msptCanadianPokerChampionship2025.schedule', title: 'tournaments.msptCanadianPokerChampionship2025.title', scheduleKeyName: 'msptCanadianPokerChampionship2025' },
          { route: 'tournaments.wsopcPlaygroundFall2025.schedule', title: 'tournaments.wsopcPlaygroundFall2025.title', scheduleKeyName: 'wsopcPlaygroundFall2025' },
          { route: 'tournaments.wsopcMontrealGGPoker2025.schedule', title: 'tournaments.wsopcMontrealGGPoker2025.title', scheduleKeyName: 'wsopcMontrealGGPoker2025' },
          { route: 'routes.pastEvents', title: 'nav.pastEvents', icon: 'pastEvents' },
          { categoryTitle: true, route: 'routes.eatAndPlay', title: 'nav.eatAndPlay', badge: 'free', icon: 'eatAndPlay' },
          { route: 'pseudoRoutes.eatAndPlay.cashMenu.path', title: 'nav.cashGameMenu', icon: 'food' },
          { route: 'pseudoRoutes.eatAndPlay.tournamentMenu.path', title: 'nav.tournamentMenu', icon: 'tournament' },
          { categoryTitle: true, route: 'routes.pokerPromotions',title: 'nav.pokerPromotions', icon: 'pokerPromos' },
          { route: 'routes.tlb', title: 'nav.tlb', icon: 'pokerPromo', scheduleKeyName: 'pokerTlb' },
          { route: 'highHands.highHandNovember2025', title: 'nav.highHandNovember2025', icon: 'pokerPromo', scheduleKeyName: 'highHandNovember2025' },
          { route: 'routes.multiMillionaireMakerSeptember2025', title: 'nav.multiMillionaireMaker2025', icon: 'pokerPromo', scheduleKeyName: 'multiMillionaireMakerSeptember2025' },
          { route: 'highHands.hotSeatsOctober2025', title: 'hotSeatsOctober2025.title', icon: 'pokerPromo', scheduleKeyName: 'hotSeatsOctober2025' },
          { route: 'routes.tripleBarrelCashBlast2025', title: 'nav.tripleBarrelCashBlast2025', icon: 'pokerPromo', scheduleKeyName: 'tripleBarrelCashBlast2025' },
          { route: 'routes.hockeyNightAtPlayground2025', title: 'nav.hockeyNight', icon: 'pokerPromo', scheduleKeyName: 'hockeyNightAtPlayground2025' },
          { route: 'routes.titanTuesday2025', title: 'nav.titanTuesday2025', icon: 'pokerPromo', scheduleKeyName: 'titanTuesday2025' },
          { route: 'routes.badBeatJackpot', title: 'nav.badBeatJackpot', icon: 'pokerPromo' },
          { route: 'routes.pokerPromotions', title: 'nav.allPokerPromotions', icon: 'pokerPromo' },
          // Leave NYE and TLB as they are used in a test file
          { route: 'routes.pokerNewYearsEve2025', title: 'nav.nye2025', scheduleKeyName: 'pokerNewYearsEve2025' },
        ],
      },
      {
        title: 'nav.gamingMachines',
        mobileTitle: "nav.playGamingMachines",
        img: 'nav/egd-menu.jpg',
        imgAlt: 'nav.gamingMachines',
        items: [
          { categoryTitle: true, route: 'routes.egd', title: 'nav.gamingMachines', img: 'nav/gaming-machines.jpg', imgAlt: 'nav.gamingMachines', icon: 'egd'},
          { route: 'routes.egdGameList', title: 'nav.egdGameList', icon: 'gameList' },
          { route: 'routes.egdRecentJackpots', title: 'nav.recentJackpots', icon: 'gameList' },
          { categoryTitle: true, route: 'routes.electronicTableGames', title: 'nav.electronicTableGames', badge: 'new', icon:'tableGames' },
          { route: 'pseudoRoutes.electronicTableGames.blackJack.path', title: 'nav.blackJack', icon: 'blackJack' },
          { route: 'pseudoRoutes.electronicTableGames.roulette.path', title: 'nav.roulette', icon: 'roulette' },
          { route: 'pseudoRoutes.electronicTableGames.baccarat.path', title: 'nav.baccarat', icon: 'baccarat' },
          { route: 'pseudoRoutes.electronicTableGames.craps.path', title: 'nav.craps', icon: 'craps' },
          // { categoryTitle: true, route: 'routes.eatAndPlay', title: 'nav.eatAndPlay', badge: 'free', icon: 'eatAndPlay' },
          // { route: 'routes.eatAndPlay', title: 'nav.drinksMenu', icon: 'food' },
          // { route: 'routes.eatAndPlay', title: 'nav.bitesMenu', icon: 'drinks' },
          { categoryTitle: true, route: 'routes.egdPromotions', title: 'nav.gamingMachinePromotions', icon: 'egdPromos' },
          // { route: 'routes.freePlayFriday', title: 'nav.freePlayFriday', icon: 'egdPromo' },
          { route: 'routes.hauntedCarnival2025', title: 'nav.hauntedCarnival2025', icon: 'egdPromo', scheduleKeyName: 'hauntedCarnival2025' },
          { route: 'routes.clubElite2025', title: 'nav.clubElite2025', icon: 'egdPromo', scheduleKeyName: 'clubElite2025' },
          { route: 'routes.winAMillion2025', title: 'nav.winAMillion2025', icon: 'egdPromo', scheduleKeyName: 'winAMillion2025' },
          { route: 'routes.newYearsEve2026', title: 'nav.newYearsEve2026', icon: 'egdPromo', scheduleKeyName: 'newYearsEve2026' },
          { route: 'routes.jackpotParty', title: 'nav.jackpotParty', icon: 'egdPromo' },
          { route: 'routes.birthdayBash2025', title: 'nav.birthdayBash2025', icon: 'egdPromo', scheduleKeyName: 'birthdayBash2025' },
          { route: 'routes.ultimateDad2025', title: 'ultimateDad2025.nav', icon: 'egdPromo', scheduleKeyName: 'ultimateDad2025' },
          { route: 'routes.nuitElite', title: 'nav.nuitElite', icon: 'egdPromo', scheduleKeyName: 'nuitElite' },
          { route: 'routes.gpFreePlay2025', title: 'gpFreePlay2025.hero.title', icon: 'egdPromo', scheduleKeyName: 'gpFreePlay2025' },
          { route: 'routes.egdPromotions', title: 'nav.allGamingMachinePromotions', icon: 'egdPromo' }
        ]
      }
    ],
  },
  {
    title: 'nav.dining',
    route: 'routes.dining',
  },
  {
    title: 'nav.entertainment',
    route: 'routes.entertainment',
  },
  {
    title: 'nav.promotions',
    route: 'routes.promotions',
  },
  {
    title: 'nav.rewards',
    route: 'routes.rewards',
  },
  // {
  //   title: 'nav.shop',
  //   route: 'https://shop.playground.ca/',
  //   isExternal: true,
  // },
];
